// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"e4248247","56":"65542626","311":"a81b22a5","336":"d1731fc9","380":"4338c88c","384":"fb563a58","392":"010970ea","417":"8ae241e2","665":"0a52b6ee","895":"6b8078fc","912":"91b3592f"}[chunkId] + ".chunk.js";
};